import { Card, Col, Row } from 'antd';
import clsx from 'clsx';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DashboardCard from '../../components/DashboardCard';
import TaskOverview from '../../components/TaskOverview';
import TaskTable from '../../components/TaskTable';
import { TASk_TABS } from '../../constants';
import { isStaff } from '../../helper';
import useRestaurants from '../../hooks/useRestaurants';
import { getTasks } from '../../redux/actions/tasks';

import { FiGrid } from 'react-icons/fi';
import { FiUser } from 'react-icons/fi';
import { FiActivity } from 'react-icons/fi';
import { FiCalendar } from 'react-icons/fi';
import { FiCheckCircle } from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const TasksDashboard = () => {
  const { id } = useParams();
  const { site_dashboard_data } = useRestaurants();

  const taskData = [
    { category: 'Unassigned', count: Number(site_dashboard_data?.analytics?.unassigned_tasks ?? 0) },
    { category: 'Pending', count: Number(site_dashboard_data?.analytics?.pending_tasks ?? 0) },
    { category: 'Completed', count: Number(site_dashboard_data?.analytics?.completed_tasks ?? 0) },
    { category: 'Overdue', count: Number(site_dashboard_data?.analytics?.overdue_tasks ?? 0) },
    { category: 'Scheduled', count: Number(site_dashboard_data?.analytics?.scheduled_tasks ?? 0) },
  ];

  const KPIs = [
    {
      title: 'Total Tasks',
      value: site_dashboard_data?.analytics?.total_tasks ?? 0,
      icon: <FiGrid />,
    },
    {
      title: 'Assigned to Me',
      value: site_dashboard_data?.analytics?.assign_me ?? 0,
      icon: <FiUser />,
      status: 'unassigned',
    },
    {
      title: 'Active Tasks',
      value: site_dashboard_data?.analytics?.pending_tasks ?? 0,
      icon: <FiActivity />,
      status: 'warning',
    },
    {
      title: 'Scheduled Tasks',
      value: site_dashboard_data?.analytics?.scheduled_tasks ?? 0,
      icon: <FiCalendar />,
      status: 'scheduled',
    },
    {
      title: 'Completed Tasks',
      value: site_dashboard_data?.analytics?.completed_tasks ?? 0,
      icon: <FiCheckCircle />,
      status: 'success',
    },
    {
      title: 'Overdue Tasks',
      value: site_dashboard_data?.analytics?.overdue_tasks ?? 0,
      icon: <FiAlertTriangle />,
      status: 'danger',
    }
  ]

  useEffect(() => {
    getTasks({ id, filter: TASk_TABS.DASHBOARD });
  }, [id]);

  return (
    <div className={clsx('TasksDashboard', { staff: isStaff() })}>
      <Row gutter={[16, 16]}>
        {KPIs.map((kpi) => (
          <Col key={kpi.title} xs={12} sm={12} md={8} lg={4}>
            <DashboardCard
              {...kpi}
            />
          </Col>
        ))}
      </Row>

      <Row gutter={[16, 16]} style={{ marginBlock: 24 }}>
        <Col xs={24} lg={14}>
          <Card title="Recent Tasks" styles={{ body: { padding: '1px 12px' } }}>
            <TaskTable data={site_dashboard_data?.recent_tasks || []} isSite={false} tableHeight={365} />
          </Card>
        </Col>
        <Col xs={24} lg={10}>
          <TaskOverview
            showHeader={false}
            title="Task Overview"
            data={taskData}
            total={site_dashboard_data?.analytics?.total_tasks ?? 0}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TasksDashboard;
